export const TOTALS = 'Totals';
export const TOTALS_HEADCELL = { value: TOTALS, type: TOTALS };

export const COLUMNS_HEADERS_STYLE_CLASS = '.MuiTableHead-root';
export const EXISTING_COULMN_HEADERS_OVERRIDE_STYLE_CLASS = 'thead tr:first-of-type .MuiTableCell-head';
